module.exports = __webpack_public_path__ + "static/media/WindsorLtBTLight.a2f3cd40.svg";